import { ComponentPropsWithoutRef, FC } from 'react';
import { useZoomableContext } from '../../context/ZoomableContext';

interface ZoomableContainerProps extends ComponentPropsWithoutRef<'div'> {}

const ZoomableContainer: FC<ZoomableContainerProps> = (props) => {
    const { children, ...rest } = props;

    const { refs } = useZoomableContext();

    return (
        <div {...rest} ref={refs.container.setReference}>
            {children}
        </div>
    );
};

export default ZoomableContainer;
